import { StyledCaseReportSectionTitle } from 'src/components/atomsLegacy';
import styled from 'styled-components';

export const Title = styled(StyledCaseReportSectionTitle)`
  text-transform: uppercase;
  margin: 10px 0 0;
`;

export const DetailContainer = styled.div<{ first?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.first && 'padding-top: 24px;'};
`;

export const Error = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.newPalette.red.R300};
  margin-top: 6px;
  margin-bottom: 0;
`;
